export const blogList = [
    {
        id: "so-many-data-formats-to-chose-from",
        title: "So many (data) formats to chose from",
        description: "A javascript implementation to format spreadsheet data",
        time: "2022/10/23 00:00:00",
        image: "https://cdn.hashnode.com/res/hashnode/image/upload/v1666401128478/nSc1cVUeG.webp",
    },
    // {
    //   id: "all_components",
    //   title: "All Blog Post Components",
    //   description: "To review design of all posible components inside a blog post",
    //   time: "2022/08/02 08:00:00",
    //   image: "https://cdn.hashnode.com/res/hashnode/image/upload/v1659519051850/_U6Rsy9T4.png",
    // },
];
